import { ActionType, AutomationActionType } from '@/types/enums'

/**
 * Shortcuts elsewhere in the app (e.g. "Notify when this tag is added" on a tag) open the automation
 * editor pre-filled through the URL; this module writes and reads those parameters.
 */
export interface AutomationPrefill {
  recordGroupId: string
  trigger?: ActionType
  tagId?: string
  action?: AutomationActionType
}

/** Triggers and actions a shortcut may preset; anything else in the URL is ignored. */
const PREFILL_TRIGGERS: ActionType[] = [ActionType.TAG_ADDED, ActionType.TAG_REMOVED]
const PREFILL_ACTIONS: AutomationActionType[] = [AutomationActionType.SEND_NOTIFICATION]

export function newAutomationLink(prefill: AutomationPrefill): string {
  const params = new URLSearchParams({ recordGroupId: prefill.recordGroupId })
  if (prefill.trigger) params.set('trigger', prefill.trigger)
  if (prefill.tagId) params.set('tagId', prefill.tagId)
  if (prefill.action) params.set('action', prefill.action)
  return `/automations/new?${params.toString()}`
}

/** Link for "notify people when this record tag is added". */
export function tagNotificationLink(recordGroupId: string, tagId: string): string {
  return newAutomationLink({
    recordGroupId,
    trigger: ActionType.TAG_ADDED,
    tagId,
    action: AutomationActionType.SEND_NOTIFICATION,
  })
}

export function readAutomationPrefill(search: string): AutomationPrefill {
  const params = new URLSearchParams(search)
  const trigger = params.get('trigger') as ActionType | null
  const action = params.get('action') as AutomationActionType | null
  const validTrigger = trigger && PREFILL_TRIGGERS.includes(trigger) ? trigger : undefined
  return {
    recordGroupId: params.get('recordGroupId') ?? '',
    trigger: validTrigger,
    // A tag only narrows a tag trigger
    tagId: validTrigger ? params.get('tagId') ?? undefined : undefined,
    action: action && PREFILL_ACTIONS.includes(action) ? action : undefined,
  }
}
